import { Box, BoxProps, Text, TextProps } from '@jfs/ui-new'
import { MerchantTheme } from '../../../data/models/Config'
import { useStores } from '../../../data/store'

export const ListHeader = ({ headerTitle }: any) => {
  const { theme } = useStores((root) => ({
    theme: root?.config?.merchantTheme,
  }))
  if (!headerTitle) {
    return null
  }
  return (
    <Box {...styles.container}>
      <Text {...styles.header(theme as any)}>{headerTitle}</Text>
    </Box>
  )
}

const styles = {
  container: {
    pt: 24,
    ph: 24,
    pb: 16,
  } as BoxProps,
  header: (theme: typeof MerchantTheme.properties) =>
    ({
      color: theme?.bodyTextColor as any,
      fontSize: 12,
      fontFamily: 'jioType-medium',
    } as TextProps),
}
